import axios from 'axios'
import store from '../../store/index'

const state = {
  subscriptions: [],
  subscription: {},
  subscriptionPack: {},
  companySubscription: {},
  companySubscriptionPacks: [],
}

const mutations = {
  subscriptions_data (state, subscriptions) {
    state.subscriptions = subscriptions
  },
  subscription_data (state, subscription) {
    state.subscription = subscription
  },
  subscription_pack_data (state, subscriptionPack) {
    state.subscriptionPack = subscriptionPack
  },
  company_subscription_data (state, subscription) {
    state.companySubscription = subscription
  },
  company_subscription_packs_data (state, packs) {
    state.companySubscriptionPacks = packs
  },
}

const actions = {
  getSubscriptions ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/subscriptions',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('subscriptions_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSubscription ({ commit }, subscriptionId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/subscriptions/getSubscription?id=' + subscriptionId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('subscription_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  // getCompanySubscription ({ commit }, subscriptionId) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       url: '/subscriptions/getCompanySubscription?id=' + subscriptionId,
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Authorization: store.getters.token,
  //       },
  //     })
  //       .then(resp => {
  //         commit('company_subscription_data', resp.data.message)
  //         resolve(resp)
  //       })
  //       .catch(err => {
  //         reject(err)
  //       })
  //   })
  // },
  getSubscriptionPack ({ commit }, subscriptionPackId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/subscriptions/pack?subscriptionPackId=' + subscriptionPackId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('subscription_pack_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSubscriptionPacks ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/companySubscription/packs',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('company_subscription_packs_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getExpiredSubscriptionPacks ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/companySubscription/packs/expired',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('company_subscription_packs_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCompanySubscription ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/companySubscription',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('company_subscription_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getCompanySubscriptionPacksLicenses ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/companySubscription/licenses',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
